/** @jsx jsx */
import { jsx } from '@emotion/core'
import { HFlow, Icon, Text } from 'bold-ui'
import { resolveName } from 'components/form'
import { MChatPerguntaEnum } from 'graphql/types.generated'
import { useField } from 'react-final-form'
import { MetaPath } from 'util/metaPath'

import { getModalFooterCounterText, getPerguntasSelecionadasFieldHasError } from '../utils-consultaSeguimento'

interface ConsultaSeguimentoModalFooterCounterProps {
  name: MetaPath<MChatPerguntaEnum[]>
  isMChatRiscoBaixo: boolean
  startFailed: boolean
}

export function ConsultaSeguimentoModalFooterCounter(props: Readonly<ConsultaSeguimentoModalFooterCounterProps>) {
  const { name, isMChatRiscoBaixo, startFailed } = props

  const {
    input: { value },
    meta,
  } = useField<MChatPerguntaEnum[]>(resolveName(name), {
    subscription: { value: true, error: true, touched: true },
  })

  const hasError = getPerguntasSelecionadasFieldHasError(meta, isMChatRiscoBaixo) || startFailed
  const numberOfPerguntasSelecionadas = value?.length
  const hasPerguntasSelecionadas = numberOfPerguntasSelecionadas > 0

  const text = getModalFooterCounterText(numberOfPerguntasSelecionadas, hasError)

  return (
    <HFlow alignItems='center' hSpacing={0.5}>
      {hasError && <Icon size={1} icon='banOutline' fill='danger' />}
      <Text color={hasError ? 'danger' : 'inherit'}>
        <strong>{hasPerguntasSelecionadas && numberOfPerguntasSelecionadas}</strong> {text}
      </Text>
    </HFlow>
  )
}
